import { ReactNode } from 'react';
import { Navigate } from 'react-router-dom';
import { PATH_DASHBOARD } from 'src/routes/paths';
import {
  canWriteStock,
  useWarehouseActivation,
} from '../hooks/useWarehouseActivation';

interface WarehouseEnabledGuardProps {
  children: ReactNode;
}

/**
 * Magazyn pages that exist only while the Warehouse is enabled (D-1,
 * 2026-09-25: Zapotrzebowania). Like WarehouseManageGuard, a page the menu does
 * not offer sends the member to Produkty; the Magazyn shell above already
 * shows the disabled notice. It waits for the activation answer, so a deep
 * link (the demand email) is never bounced while it loads.
 */
export default function WarehouseEnabledGuard({
  children,
}: WarehouseEnabledGuardProps): JSX.Element | null {
  const activation = useWarehouseActivation();
  if (!activation.isSuccess) {
    return null;
  }
  return canWriteStock(activation.data) ? (
    <>{children}</>
  ) : (
    <Navigate to={PATH_DASHBOARD.warehouse.products} replace />
  );
}
